/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { MdQuestionMark } from "react-icons/md";
import Swal from "sweetalert2";

const PricingInformationFields = () => {
  const {
    control,
    trigger,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext(); // Access form context

  const applyWeekendPrice = watch("apply_weekend_price");
  const watchFieldArray = watch("custom_periods");

  const { fields, append, remove } = useFieldArray({
    control, // Pass the control object from `useForm`
    name: "custom_periods", // Name of the field array
  });

  // Combine field metadata and watched values for each dependant
  const customPeriodsList = fields.map((field, index) => {
    return {
      ...field, // Include field metadata from `useFieldArray`
      ...watchFieldArray?.[index], // Include watched values from `watch`
    };
  });

  const additionalGuest = watch("additional_guest");
  const petsAllowed = watch("pet_allowed");
  const customPeriodPricing = watch("custom_period_pricing");
  console.log({ customPeriodPricing });
  return (
    <div className="mt-4">
      <h4 className="mb-2 text-2xl font-bold">Pricing</h4>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
        <div className="col-span-1">
          <label
            htmlFor="instant_booking"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Instant Booking
          </label>
          <Controller
            name="instant_booking"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="instant_booking"
                className={`w-full rounded-md border p-3  ${
                  errors?.instant_booking?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value={1}>Yes</option>
                <option value={0}>No</option>
              </select>
            )}
          />
          {errors?.instant_booking?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.instant_booking?.message}
            </p>
          )}
        </div>
        <div className="col-span-1">
          <label
            htmlFor="nightly_price"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Nightly Price
          </label>
          <Controller
            name="nightly_price"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="nightly_price"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.nightly_price?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.nightly_price?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.nightly_price?.message}
            </p>
          )}
        </div>
        <div className="col-span-1">
          <label
            htmlFor="nightly_price_seven_plus"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Nightly Price (if 7+ nights)
          </label>
          <Controller
            name="nightly_price_seven_plus"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="nightly_price_seven_plus"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.nightly_price_seven_plus?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.nightly_price_seven_plus?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.nightly_price_seven_plus?.message}
            </p>
          )}
        </div>

        <div className="col-span-1">
          <label
            htmlFor="nightly_price_thirty_plus"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Nightly Price (if 30+ nights)
          </label>
          <Controller
            name="nightly_price_thirty_plus"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="nightly_price_thirty_plus"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.nightly_price_thirty_plus?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.nightly_price_thirty_plus?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.nightly_price_thirty_plus?.message}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="col-span-1">
          <label
            htmlFor="apply_weekend_price"
            className="mb-1 flex items-center text-sm font-medium text-gray-700"
          >
            Apply Weekend Price
            <MdQuestionMark
              onClick={() =>
                Swal.fire({
                  text: `Use this only if you plan on charging a different nightly price on the weekends.`,
                  icon: "question",
                })
              }
              style={{
                color: "#fff",
                background: "#8ec639",
                borderRadius: "50%",
                fontWeight: "bold",
                fontSize: "1.2rem",
                marginLeft: "8px",
                boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
                border: "2px solid #8ec639",
                cursor: "pointer",
                padding: "2px",
                animation: "pulse-glow 1.2s infinite alternate",
              }}
              className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
              title="Info."
            />
          </label>
          <Controller
            name="apply_weekend_price"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="apply_weekend_price"
                className={`w-full rounded-md border p-3  ${
                  errors?.apply_weekend_price?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={(e) => {
                  onChange(e);
                  if (e.target.value === "None") {
                    setValue("weekend_nightly_price", "");
                  }
                  trigger("weekend_nightly_price");
                }}
              >
                <option value="None">None</option>
                <option value="Friday and Saturday">Friday and Saturday</option>
                <option value="Saturday and Sunday">Saturday and Sunday</option>
                <option value="Friday, Saturday, and Sunday">
                  Friday, Saturday, and Sunday
                </option>
              </select>
            )}
          />
          {errors?.apply_weekend_price?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.apply_weekend_price?.message}
            </p>
          )}
        </div>

        <div className="col-span-1">
          <label
            htmlFor="weekend_nightly_price"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Weekend Nightly Price
          </label>
          <Controller
            name="weekend_nightly_price"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="weekend_nightly_price"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.weekend_nightly_price?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={(e) => {
                  onChange(e);
                  trigger("apply_weekend_price");
                }}
              />
            )}
          />
          {errors?.weekend_nightly_price?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.weekend_nightly_price?.message}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="col-span-1">
          <label
            htmlFor="additional_guest"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Additional Guests Allowed
          </label>
          <Controller
            name="additional_guest"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="additional_guest"
                className={`w-full rounded-md border p-3  ${
                  errors?.additional_guest?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value={1}>Yes</option>
                <option value={0}>No</option>
              </select>
            )}
          />
          {errors?.additional_guest?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.additional_guest?.message}
            </p>
          )}
        </div>

        <>
          <div className="col-span-1">
            <label
              htmlFor="no_of_additional_guest"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              No Of Additional Guests
            </label>
            <Controller
              name="no_of_additional_guest"
              control={control}
              render={({ field: { onChange, value } }) => (
                <input
                  id="no_of_additional_guest"
                  type="number"
                  className={`w-full rounded-md border px-4 py-3  ${
                    errors?.no_of_additional_guest?.message
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors?.no_of_additional_guest?.message && (
              <p className="mt-1 text-sm text-red-500">
                {errors?.no_of_additional_guest?.message}
              </p>
            )}
          </div>

          <div className="col-span-1">
            <label
              htmlFor="additional_guest_price"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Price Per Additional Guest
            </label>
            <Controller
              name="additional_guest_price"
              control={control}
              render={({ field: { onChange, value } }) => (
                <input
                  id="additional_guest_price"
                  type="number"
                  className={`w-full rounded-md border px-4 py-3  ${
                    errors?.additional_guest_price?.message
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors?.additional_guest_price?.message && (
              <p className="mt-1 text-sm text-red-500">
                {errors?.additional_guest_price?.message}
              </p>
            )}
          </div>
        </>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="col-span-1">
          <label
            htmlFor="pet_allowed"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Pets Allowed
          </label>
          <Controller
            name="pet_allowed"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="pet_allowed"
                className={`w-full rounded-md border p-3  ${
                  errors?.pet_allowed?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value={1}>Yes</option>
                <option value={0}>No</option>
              </select>
            )}
          />
          {errors?.pet_allowed?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.pet_allowed?.message}
            </p>
          )}
        </div>

        <>
          <div className="col-span-1">
            <label
              htmlFor="no_of_pets"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              No Of Pets Allowed
            </label>
            <Controller
              name="no_of_pets"
              control={control}
              render={({ field: { onChange, value } }) => (
                <input
                  id="no_of_pets"
                  type="number"
                  className={`w-full rounded-md border px-4 py-3  ${
                    errors?.no_of_pets?.message
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors?.no_of_pets?.message && (
              <p className="mt-1 text-sm text-red-500">
                {errors?.no_of_pets?.message}
              </p>
            )}
          </div>

          <div className="col-span-1">
            <label
              htmlFor="price_per_pet"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Price Per Pet
            </label>
            <Controller
              name="price_per_pet"
              control={control}
              render={({ field: { onChange, value } }) => (
                <input
                  id="price_per_pet"
                  type="number"
                  className={`w-full rounded-md border px-4 py-3  ${
                    errors?.price_per_pet?.message
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors?.price_per_pet?.message && (
              <p className="mt-1 text-sm text-red-500">
                {errors?.price_per_pet?.message}
              </p>
            )}
          </div>
        </>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="col-span-1">
          <label
            htmlFor="cleaning_fee"
            className="mb-1 flex items-center text-sm font-medium text-gray-700"
          >
            Cleaning Fee
            <MdQuestionMark
              onClick={() =>
                Swal.fire({
                  text: `No one gets excited about a cleaning fee. If it can’t be put right into the nightly rate, no worries—just keep it close to the actual cleaning cost. Guests love transparency, and no one wants to feel like they’re paying more than what they estimate it should be.`,
                  icon: "question",
                })
              }
              style={{
                color: "#fff",
                background: "#8ec639",
                borderRadius: "50%",
                fontWeight: "bold",
                fontSize: "1.2rem",
                marginLeft: "8px",
                boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
                border: "2px solid #8ec639",
                cursor: "pointer",
                padding: "2px",
                animation: "pulse-glow 1.2s infinite alternate",
              }}
              className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
              title="Info."
            />
          </label>
          <Controller
            name="cleaning_fee"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="cleaning_fee"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.cleaning_fee?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.cleaning_fee?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.cleaning_fee?.message}
            </p>
          )}
        </div>

        <div className="col-span-1">
          <label
            htmlFor="cleaning_freq"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Per Stay / Daily
          </label>
          <Controller
            name="cleaning_freq"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="cleaning_freq"
                className={`w-full rounded-md border p-3  ${
                  errors?.cleaning_freq?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value="">None</option>
                <option value="Per stay">Per stay</option>
                <option value="Daily">Daily</option>
              </select>
            )}
          />
          {errors?.cleaning_freq?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.cleaning_freq?.message}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="col-span-1">
          <label
            htmlFor="city_fee"
            className="mb-1 flex items-center text-sm font-medium text-gray-700"
          >
            City Fee
            <MdQuestionMark
              onClick={() =>
                Swal.fire({
                  text: `VERY RARE. Please check with your city to see if they have one. In New York City, for example, Guests pay an occupancy tax of 5.875% along with a flat 'hotel unit fee' of $1.50 per unit per day. It is this flat fee that we are referring to when we ask if a City Fee applies. If there isn't one, leave this blank.`,
                  icon: "question",
                })
              }
              style={{
                color: "#fff",
                background: "#8ec639",
                borderRadius: "50%",
                fontWeight: "bold",
                fontSize: "1.2rem",
                marginLeft: "8px",
                boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
                border: "2px solid #8ec639",
                cursor: "pointer",
                padding: "2px",
                animation: "pulse-glow 1.2s infinite alternate",
              }}
              className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
              title="Info."
            />
          </label>
          <Controller
            name="city_fee"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="city_fee"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.city_fee?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.city_fee?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.city_fee?.message}
            </p>
          )}
        </div>

        <div className="col-span-1">
          <label
            htmlFor="city_fee_freq"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Per Stay / Daily
          </label>
          <Controller
            name="city_fee_freq"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="city_fee_freq"
                className={`w-full rounded-md border p-3  ${
                  errors?.city_fee_freq?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value="">None</option>
                <option value="Per stay">Per stay</option>
                <option value="Daily">Daily</option>
              </select>
            )}
          />
          {errors?.city_fee_freq?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.city_fee_freq?.message}
            </p>
          )}
        </div>
        <div className="col-span-1">
          <label
            htmlFor="tax_percentage"
            className="mb-1 flex items-center text-sm font-medium text-gray-700"
          >
            Tax percentage
            <MdQuestionMark
              onClick={() =>
                Swal.fire({
                  text: `Please check with your State, County, and City to see what sales tax rates PLUS lodging tax rates, if any, are applied to short-term rentals. ADD ALL TAX RATES TOGETHER and enter that number in the field. FYI: Lodging tax is also known as Hotel Tax, Occupancy Tax, Tourist Tax, Transient Occupancy Tax (TOT), Bed Tax, Visitor Tax, Accommodation Tax, Resort Tax, City Tax, Tourism Levy, and Hospitality Tax, among other names.`,
                  icon: "question",
                })
              }
              style={{
                color: "#fff",
                background: "#8ec639",
                borderRadius: "50%",
                fontWeight: "bold",
                fontSize: "1.2rem",
                marginLeft: "8px",
                boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
                border: "2px solid #8ec639",
                cursor: "pointer",
                padding: "2px",
                animation: "pulse-glow 1.2s infinite alternate",
              }}
              className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
              title="Info."
            />
          </label>
          <Controller
            name="tax_percentage"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="tax_percentage"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.tax_percentage?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
                placeholder="Combined State, County, City & Lodging Tax"
              />
            )}
          />
          {errors?.tax_percentage?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.tax_percentage?.message}
            </p>
          )}
        </div>
      </div>

      <h4 className="mb-2 mt-4 text-2xl font-bold flex items-center">
        Set Up Custom Period Pricing
        <MdQuestionMark
          onClick={() =>
            Swal.fire({
              text: `This section is for specifying dates when you want to charge a different price from your regular nightly rate. For example, some Hosts may increase rates during peak seasons like Christmas, while others may offer discounted rates during off-peak periods, such as winter, to attract more guests.`,
              icon: "question",
            })
          }
          style={{
            color: "#fff",
            background: "#8ec639",
            borderRadius: "50%",
            fontWeight: "bold",
            fontSize: "1.2rem",
            marginLeft: "8px",
            boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
            border: "2px solid #8ec639",
            cursor: "pointer",
            padding: "2px",
            animation: "pulse-glow 1.2s infinite alternate",
          }}
          className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
          title="Info."
        />
      </h4>

      <div className="mt-4 grid grid-cols-1 gap-4">
        <div className="col-span-1">
          <label
            htmlFor="custom_period_pricing"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Custom period pricing
          </label>
          <Controller
            name="custom_period_pricing"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="custom_period_pricing"
                className={`w-full rounded-md border p-3  ${
                  errors?.custom_period_pricing?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value={1}>Yes</option>
                <option value={0}>No</option>
              </select>
            )}
          />
          {errors?.custom_period_pricing?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.custom_period_pricing?.message}
            </p>
          )}
          {!errors?.custom_period_pricing?.message && (
            <small className="mt-1 block text-sm text-gray-500">
              Do you want to set up custom period pricing?
            </small>
          )}
        </div>
      </div>

      {customPeriodPricing == 1 && (
        <>
          {customPeriodsList?.map((period, index) => {
            return (
              <div key={period.id} id="custom_periods">
                <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div className="col-span-1">
                    <label
                      htmlFor={`custom_periods[${index}].start_date`}
                      className="mb-1 block text-sm font-medium text-gray-700"
                    >
                      Start Date
                    </label>
                    <Controller
                      name={`custom_periods[${index}].start_date`}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <input
                          id={`custom_periods[${index}].start_date`}
                          type="date"
                          className={`w-full rounded-md border px-4 py-3  ${
                            errors.custom_periods?.[index]?.start_date?.message
                              ? "border-red-500"
                              : "border-gray-300"
                          }`}
                          value={value}
                          onChange={onChange}
                        />
                      )}
                    />
                    {errors.custom_periods?.[index]?.start_date?.message && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.custom_periods?.[index]?.start_date?.message}
                      </p>
                    )}
                  </div>

                  <div className="col-span-1">
                    <label
                      htmlFor={`custom_periods[${index}].end_date`}
                      className="mb-1 block text-sm font-medium text-gray-700"
                    >
                      End Date
                    </label>
                    <Controller
                      name={`custom_periods[${index}].end_date`}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <input
                          id={`custom_periods[${index}].end_date`}
                          type="date"
                          className={`w-full rounded-md border px-4 py-3  ${
                            errors.custom_periods?.[index]?.end_date?.message
                              ? "border-red-500"
                              : "border-gray-300"
                          }`}
                          value={value}
                          onChange={onChange}
                        />
                      )}
                    />
                    {errors.custom_periods?.[index]?.end_date?.message && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.custom_periods?.[index]?.end_date?.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
                  <div className="col-span-1">
                    <label
                      htmlFor={`custom_periods[${index}].nightly_price`}
                      className="mb-1 block text-sm font-medium text-gray-700"
                    >
                      Custom price
                    </label>
                    <Controller
                      name={`custom_periods[${index}].nightly_price`}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <input
                          id={`custom_periods[${index}].nightly_price`}
                          type="number"
                          className={`w-full rounded-md border px-4 py-3  ${
                            errors.custom_periods?.[index]?.nightly_price
                              ?.message
                              ? "border-red-500"
                              : "border-gray-300"
                          }`}
                          value={value}
                          onChange={onChange}
                        />
                      )}
                    />
                    {errors.custom_periods?.[index]?.nightly_price?.message && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.custom_periods?.[index]?.nightly_price?.message}
                      </p>
                    )}
                  </div>
                  {/* <div className="col-span-1">
                    <label
                      htmlFor={`custom_periods[${index}].weekend_price`}
                      className="mb-1 block text-sm font-medium text-gray-700"
                    >
                      Custom weekly price
                    </label>
                    <Controller
                      name={`custom_periods[${index}].weekend_price`}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <input
                          id={`custom_periods[${index}].weekend_price`}
                          type="number"
                          className={`w-full rounded-md border px-4 py-3  ${
                            errors.custom_periods?.[index]?.weekend_price
                              ?.message
                              ? "border-red-500"
                              : "border-gray-300"
                          }`}
                          value={value}
                          onChange={onChange}
                        />
                      )}
                    />
                    {errors.custom_periods?.[index]?.weekend_price?.message && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.custom_periods?.[index]?.weekend_price?.message}
                      </p>
                    )}
                  </div> */}
                  <div className="col-span-1">
                    <label
                      htmlFor={`custom_periods[${index}].price_add_guest`}
                      className="mb-1 block text-sm font-medium text-gray-700"
                    >
                      Price per additional guest
                    </label>
                    <Controller
                      name={`custom_periods[${index}].price_add_guest`}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <input
                          id={`custom_periods[${index}].price_add_guest`}
                          type="number"
                          className={`w-full rounded-md border px-4 py-3  ${
                            errors.custom_periods?.[index]?.price_add_guest
                              ?.message
                              ? "border-red-500"
                              : "border-gray-300"
                          }`}
                          value={value}
                          onChange={onChange}
                        />
                      )}
                    />
                    {errors.custom_periods?.[index]?.price_add_guest
                      ?.message && (
                      <p className="mt-1 text-sm text-red-500">
                        {
                          errors.custom_periods?.[index]?.price_add_guest
                            ?.message
                        }
                      </p>
                    )}
                  </div>
                </div>

                <div className="mt-4 grid grid-cols-1">
                  {customPeriodsList?.length > 1 && (
                    <div className="col-span-1 flex justify-end">
                      <button
                        type="button"
                        className="rounded-md border border-red-500 bg-white px-4 py-2 text-sm font-medium text-red-500 shadow-sm hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                        onClick={() => remove(index)}
                      >
                        Remove Custom period
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          <button
            type="button"
            className="mt-2 rounded-md border border-indigo-500 bg-white px-4 py-2 text-sm font-medium text-indigo-500 shadow-sm hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={() => {
              append({
                start_date: null,
                end_date: null,
                nightly_price: "",
                price_add_guest: "",
              });
            }}
          >
            Add custom period
          </button>
        </>
      )}
    </div>
  );
};

export default memo(PricingInformationFields);
